<div class="relative overflow-hidden hero-bg">
    <!-- Hero Section -->
    <section class="relative pt-20 pb-32 lg:pt-32 lg:pb-40 container mx-auto px-4 text-center fade-in">
        <div
            class="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent text-white text-xs font-semibold mb-6 uppercase tracking-wider shadow-sm">
            <mat-icon class="text-xs h-4 w-4" style="font-size: 16px; width: 16px; height: 16px;">star</mat-icon>
            Nuevo sistema de reservas v2.0
        </div>

        <h1 class="mat-display-3 font-bold tracking-tight text-gray-900 mb-6 max-w-4xl mx-auto leading-tight">
            Gestione sus citas con <br />
            <span class="text-primary">Elegancia y Precisión</span>
        </h1>

        <p class="mat-headline-6 text-gray-600 mb-10 max-w-2xl mx-auto leading-relaxed">
            La plataforma todo en uno para profesionales que valoran su tiempo. Automatice reservas, recordatorios y
            pagos en una interfaz diseñada para enamorar.
        </p>

        <div class="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a mat-raised-button color="primary" routerLink="/auth/register" class="hero-button">
                <mat-icon>rocket_launch</mat-icon>
                Comenzar Gratis
            </a>
            <a mat-stroked-button color="primary" routerLink="/demo" class="hero-button">
                <mat-icon>play_circle_outline</mat-icon>
                Ver Demo
            </a>
        </div>

        <!-- Social Proof / Trust -->
        <div class="mt-16 pt-8 border-t border-gray-100 flex flex-col items-center gap-4">
            <p class="mat-caption text-gray-500 font-medium">Confiado por +1,000 profesionales</p>
            <div class="flex gap-8 grayscale opacity-50">
                <div class="h-8 w-24 bg-gray-300 rounded animate-pulse"></div>
                <div class="h-8 w-24 bg-gray-300 rounded animate-pulse delay-100"></div>
                <div class="h-8 w-24 bg-gray-300 rounded animate-pulse delay-200"></div>
            </div>
        </div>
    </section>
</div>